import * as React from 'react';
import {DefaultButton, Dialog, DialogFooter, DialogType, PrimaryButton} from '@fluentui/react';
import {useContext} from "react";
import AuthContext from "../../Services/AuthContext";

function DeleteTask(props) {
    const [user] = useContext(AuthContext);

    const dialogContentProps = {
        type: DialogType.normal,
        title: 'Usuń zadanie',
        closeButtonAriaLabel: 'Close',
        subText: 'Czy na pewno chcesz usunąć to zadanie?',
    };

    const _delete = () => {
        fetch(`/api/task/${props.open}`, {
                method: 'DELETE',
                headers: {
                    'Authorization': 'Bearer ' + user.token
                }
            }).then(res => res.json())
                .then(data => {
                    props.onSuccess();
                    props.dismiss();
                })
                .catch(err => {
                    console.log(err)
                })
    }

    return (
        <Dialog
            hidden={!props.open}
            onDismiss={props.dismiss}
            dialogContentProps={dialogContentProps}
        >
            <DialogFooter>
                <PrimaryButton onClick={_delete} text="Usuń" />
                <DefaultButton onClick={props.dismiss} text="Anuluj" />
            </DialogFooter>
        </Dialog>
    )
}

export default DeleteTask;